import { RowContent } from 'components/ModalsContainer/v1Modals/PatientSummary/common'

type PrescriberProps = {
  providerName: string
}

const Prescriber = ({ providerName }: PrescriberProps) => {
  if (!providerName) {
    return null
  }

  return (
    <div className="mb-5">
      <h6 className="typography-body-xl text-primary-800 font-medium mb-4">Prescriber</h6>
      <RowContent label={'Name'} content={providerName} />
    </div>
  )
}

export default Prescriber
